export enum MapNames {
    Clubhouse = 'Clubhouse'
    // Adicione mais nomes de mapas aqui
}

export enum Floor {
    Basement = 'Basement',
    FirstFloor = '1st Floor',
    SecondFloor = '2nd Floor',
    Roof = 'Roof'
}
